'use client';

import * as React from 'react';

import { ResourceBadge } from '@/components/ui/resource-badge';
import { formatMoney } from "@/lib/money";
import { useOrgNavigate } from '@/hooks/use-app-navigate';

interface ProcessorResourceBadgeProps {
  processorId: string;
  amount?: number;
  currency?: string;
  variant?: 'default' | 'secondary' | 'destructive' | 'outline';
  className?: string;
}

/**
 * PaymentResourceBadge component for displaying payment information
 * Inherits from generic ResourceBadge
 */
export function ProcessorResourceBadge({
  processorId,
  amount,
  currency = 'USD',
  variant = 'secondary',
  className,
}: ProcessorResourceBadgeProps) {
  const { orgRoutes } = useOrgNavigate();
  // Format display value based on available data
  const displayValue = React.useMemo(() => {
    if (amount !== undefined) {
      return formatMoney(amount, currency);
    }
    return `${processorId.substring(0, 8)}...`;
  }, [amount, currency, processorId]);

  return (
    <ResourceBadge
      name="processor"
      value={displayValue}
      appLink={orgRoutes.PROCESSOR_DETAILS(processorId)}
      variant={variant}
      className={className}
    />
  );
}
